import { render, staticRenderFns } from "./RowInfoDetail.vue?vue&type=template&id=ef9a101e&scoped=true&"
import script from "./RowInfoDetail.vue?vue&type=script&lang=js&"
export * from "./RowInfoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9a101e",
  null
  
)

export default component.exports